/*global ALKMaps*/
const config = require("config");

(function () {
  var serviceId = "siteService";
  angular
    .module("alk.maps")
    .factory(serviceId, ["$http", "$window", "$rootScope", "$q", "$compile", "$filter", "_",
      "mapService", "mapUtilities", "LocationItem", "customPlaceSetService", "favoriteLocationsService",
      function siteService($http, $window, $rootScope, $q, $compile, $filter, _,
        mapService, mapUtilities, LocationItem, customPlaceSetService, favoriteLocationsService) {

        /*
          Workflow:
          1
            1.1 When menu controller is initialized, it will call initializeSetLayers() function, which will creates one custom set layer for ALL custom sets save features in cachedFeatures.
            No features are added at this moment.
          2. When user enables/disables custom places, siteService will:
            2.1 set value for customPlacesEnabled
            2.2 show/hide custom place sites layer controlled in mapService
            2.3 call updateCustomSetLayer() once to update custom places layer for POIs.
          4. When user pans or zooms the map, menu controller will receive MapMove event and call siteService to updateCustomSetLayer. Only if customPlacesEnabled is true and zoom level
            is no smaller than 10, will it show POIs.
        */
        var placeSets = [];
        var setLayers = [];
        var customPlacesEnabled = false;
        let isCustomPlacesRetrieved = false;

        var baseLayerStyleMap = new ALKMaps.StyleMap({
          "default": new ALKMaps.Style({
            pointRadius: "${radius}",
            strokeColor: "#fff",
            fillColor: "${fill}",
            fontColor: "#fff",
            fontSize: "10px",
            label: "${label}"
          }, {
            context: {
              fill: function (feature) {
                return (feature.cluster) ? feature.cluster[0].attributes.setStyle.color : "#ccc";
              },
              label: function (feature) {
                return (feature.cluster) ? feature.cluster.length : "";
              },
              radius: function (feature) {
                var r = 9;
                var order = Math.floor(Math.log(feature.cluster.length) / Math.LN10 + 0.000000001); // because float math sucks like that
                return r + (order * 2); //make circle bigger for each order of magnitude
              }
            }
          })
        });

        // 1. Create set layer for each alk/custom place sets
        // 2. Add customPlaceSelectCtrl for all set layers
        // 3. Add hover, out and click event listeners for each set layer
        function initializeSetLayers() {
          const initializeSetLayer = function (sets, clusterConfig, isALKPlaceSet) {
            const layerName = isALKPlaceSet ? "ALKPlaceSetLayer" : "CustomPlaceSetLayer";
            const setLayer = new ALKMaps.Layer.VectorMarkers(layerName, {
              strategies: [ new ALKMaps.Strategy.Cluster(clusterConfig) ]
            }, {
              visibility: true
            });
            setLayer.styleMap = baseLayerStyleMap;
            mapService.getMapFromId().map.addLayers([ setLayer ]);
            setLayers[layerName] = setLayer;

            //Add the places
            addPlaceSetsToLayer(sets, isALKPlaceSet, layerName)
          }

          placeSets = _.values(favoriteLocationsService.getAsSets());

          // favoriteLocationsService.getAsSets() can return a set as undefined if the account
          // or user has not saved a shared or private favorite location to create the account
          // or user level favorite set
          placeSets = placeSets.forEach(set => {
            set = typeof set === "undefined" ? [] : set;
          })

          initializeSetLayer(placeSets, {
            distance: 12,
            threshold: 2,
            maxZoomLevel: 15,
            autoActivate: true
          }, false);

          const allSetLayers = getALLSetLayersFromMap();

          mapService.resetFeatureEventControl();

          for (let i = 0; i < allSetLayers.length; i++) {
            createFeatureHoverSelect(allSetLayers[i]);
          }
        }

        const getPinStyle = function (style, isALKPlaceSet) {
          style = style || "{}";
          style = JSON.parse(style);
          if (!style.Icon) {
            style.Icon = "other";
          }
          let graphicUrl, size;
          if (isALKPlaceSet) {
            graphicUrl = `/img/poi-icons/alk_poi_${ style.Icon }.png`;
            size = 25;
          } else {
            graphicUrl = `/img/poi-icons/poi_${ style.Icon }.png`;
            size = 20;
          }
          const baseStyle = {
            externalGraphic: graphicUrl,
            graphicHeight: size,
            graphicWidth: size,
          };
          return baseStyle;
        }

        function addPlaceSetsToLayer (sets, isALKPlaceSet, layerName) {
          const pins = [];

          _.forEach(sets, set => {
            var setStyle = JSON.parse(set.Style || "{}");
            // parse places to features and save to cachedFeatures
            _.forEach(set.Places, place => {
              const ll = {
                lon: place.Coords.Lon,
                lat: place.Coords.Lat
              };
              const lonLat = mapUtilities.LLtoMerc(ll.lon, ll.lat);
              // create pin
              const geometry = new ALKMaps.Geometry.Point(ll.lon, ll.lat);
              geometry.transform(new ALKMaps.Projection("EPSG:4326"), mapService.getMap().getProjectionObject()); //transform to mercator
              const style = getPinStyle(set.Style, isALKPlaceSet);
              const pin = new ALKMaps.Feature.Vector(geometry, {}, style);
              pin.setId = set.Id;
              // pchen: customPlaceSetService returns a bunch of LocationItems instead of DAPlaces
              pin.place = place.ALKObj;
              pin.lonlat = lonLat;

              pin.attributes.draggable = false;
              pin.attributes.setStyle = setStyle;
              pins.push(pin);
            });});

          const layer = mapService.getLayersFromMap({
            name: layerName
          });
          //This stores all the features. Use this, not layer.features, because layer.features only stores features currently in viewport
          layer[0].cachedFeatures = layer[0].cachedFeatures ? layer[0].cachedFeatures.concat(pins) : pins;
        }

        function isCustomPlacesEnabled() {
          return customPlacesEnabled;
        }

        function enableCustomPlaces() {
          customPlacesEnabled = true;
          if (!isCustomPlacesRetrieved) {
            customPlaceSetService.getCustomPlaceSets()
              .then(customPlaceSets => {
                placeSets = customPlaceSets;
                addPlaceSetsToLayer(customPlaceSets, false, "CustomPlaceSetLayer");
                mapService.showCustomSitesLayer();
                updateCustomSetLayer();
                isCustomPlacesRetrieved = true;
              });
          } else {
            mapService.showCustomSitesLayer();
            updateCustomSetLayer();
          }
        }

        function disableCustomPlaces() {
          customPlacesEnabled = false;
          mapService.hideCustomSitesLayer();
          updateCustomSetLayer();
        }

        function reDrawPlaces(layer) {
          const mapBounds = mapService.getMapFromId().map.calculateBounds();
          if (layer) {
            layer.removeAllFeatures();
            addFeaturesToLayer(layer);
            layer.redraw();
          }
        }

        function updateCustomSetLayer() {
          const layers = getCustomSetLayerFromMap();
          if (isCustomPlacesEnabled() && mapService.currentZoom() >= 10) {
            for (let i = 0; i < layers.length; i++) {
              if (layers[i] && (!layers[i].features || layers[i].features.length === 0)) {
                layers[i].strategies[0].activate();
              }
              reDrawPlaces(layers[i]);
            }
          } else {
            for (let i = 0; i < layers.length; i++) {
              if (layers[i] && layers[i].features && layers[i].features.length > 0) {
                layers[i].strategies[0].deactivate();
                layers[i].removeAllFeatures();
              }
            }
          }
        }

        /////////////////////////////////////////////////////////////////
        // Internal helper function
        /////////////////////////////////////////////////////////////////
        function createFeatureHoverSelect(setLayer) {

          const getPlaceFromFeature = function(feature) {
            if (!feature) {
              return null;
            }
            if (feature.place) {
              return feature.place;
            }
            return null;
          }

          setLayer.events.register("featureclicked", this, (featureEvent) => {
            const feature = featureEvent.feature;
            let location = getPlaceFromFeature(feature);
            if (location) {
              // remove pop up first
              if (location.CityStateZip === null || location.CityStateZip === undefined) {
                if (location.PlaceName !== null && location.PlaceName !== undefined) {
                  location = new LocationItem(location, location.PlaceName)
                } else {
                  location = new LocationItem(location);
                }
              }
              $rootScope.$broadcast("MapPlaceClick", location);
            }
          });

          //When hovering over a place POI
          setLayer.events.register("overFeature", this, (featureEvent) => {
            const feature = featureEvent.feature;
            const location = getPlaceFromFeature(feature);
            if (location) {
              $rootScope.$broadcast("MapPlaceHover", location);
            }
          });

          setLayer.events.register("outFeature", this, (featureEvent) => {
            $rootScope.$broadcast("MapPlaceHoverOut");
          });
        }


        function addFeaturesToLayer(layer) {
          const featuresToAdd = [];
          const mapBounds = mapService.getMapFromId().map.calculateBounds();
          for (const feature of layer.cachedFeatures) {
            if (!mapBounds) { //Only happens in tests
              featuresToAdd.push(feature);
            } else if (feature.lonlat && mapBounds.containsLonLat(feature.lonlat)) {
              featuresToAdd.push(feature);
            }
          }
          //console.log("Re-adding " + featuresToAdd.length + " features");
          layer.addFeatures(featuresToAdd);
        }

        function getALLSetLayersFromMap() {
          return mapService.getLayersFromMap((s) => {
            return s.name.indexOf("PlaceSetLayer") > -1
          });
        }

        function getALKSetLayerFromMap() {
          return mapService.getLayersFromMap((s) => {
            return s.name.indexOf("ALKPlaceSetLayer") > -1
          });
        }

        function getCustomSetLayerFromMap() {
          return mapService.getLayersFromMap((s) => {
            return s.name.indexOf("CustomPlaceSetLayer") > -1
          });
        }

        /////////////////////////////////////////////////////////////////
        // Define the functions and properties to reveal
        /////////////////////////////////////////////////////////////////
        var service = {
          initializeSetLayers: initializeSetLayers,
          isCustomPlacesEnabled: isCustomPlacesEnabled,
          enableCustomPlaces: enableCustomPlaces,
          disableCustomPlaces: disableCustomPlaces,
          updateCustomSetLayer: updateCustomSetLayer
        };

        return service;
      }
    ]);
})();



// WEBPACK FOOTER //
// ./app/map/site.service.js